module.exports = __webpack_public_path__ + "img/hk-bg.c2c6be97.png";